import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowDown, FiBookOpen } = FiIcons;

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-backdrop" />
      <div className="fog fog-one" />
      <div className="fog fog-two" />
      <div className="sigil" aria-hidden="true">
        <span>✦</span>
      </div>
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 35 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <p className="eyebrow">Urban fantasy author</p>
        <h1>Magic lives<br /><em>in the shadows.</em></h1>
        <p className="hero-copy">
          Magic is real, the weapons are cursed pocket junk, and one graveyard-shift clerk has nine days to save his Texas town.
        </p>
        <a className="primary-button" href="#books">
          <SafeIcon icon={FiBookOpen} /> Discover the books
        </a>
      </motion.div>
      <a className="scroll-cue" href="#books" aria-label="Scroll to books">
        <span>Cross the veil</span>
        <SafeIcon icon={FiArrowDown} />
      </a>
    </section>
  );
}
